<template lang="pug">
  .groupInfo(v-loading="isLoading")
    template(v-if="group")
      .info
        .bottons
          el-button(@click="openUpdateDialog" icon="el-icon-edit" size="mini")
          el-button(@click="isShowingGroupDeleteDialog=true" icon="el-icon-delete" size="mini" type="danger")
        h1 {{ group.name }}
        p.note(v-if="group.description.length>0") {{ group.description }}
        p.manager
          el-tag(type="info" size="small") {{ $t('Cuona.Group.manager_name') }}
          span.manager {{ group.manager.name }}

      .attached
        h2 {{ $t('Cuona.Group.title01') }}
          span.count {{ group.devices.length }}
        DevicesTable(:devices="group.devices" :edit="true" :loading="false" @openDialog="isShowingAddDevicesDialog=true")

      .events
        h2 {{ $t('Cuona.Group.title07') }}
          span.count {{ group.events.length }}
        EventsTable(:events="group.events" :edit="false" :isGroupHidden="true" :loading="false" :actions="actions" @openDialog="isShowingAddEventsDialog=true")

      el-dialog(:title="$t('Cuona.Group.title05')" width="65%" top="8vh" :visible.sync="isShowingGroupUpdateDialog" @open="openedUpdateDialog" @closed="closedDialog")
        el-form.form(label-position="left" :rules="rules" label-width="120px" ref="updateDialogForm" :model="updateDialogForm" v-loading="isLoading")
          el-form-item(:label="$t('Cuona.Group.name')" prop="name")
            el-input(v-model="updateDialogForm.name")
          el-form-item(:label="$t('Cuona.Group.manager')" prop="managerId")
            el-select(v-model="updateDialogForm.managerId" :placeholder="$t('Cuona.Group.choice')")
              el-option(v-for="(manager, index) in ownerAndManagers" :label="manager.name" :value="manager.id" :key="index")
          el-form-item(:label="$t('Cuona.Group.note')")
            el-input(type="textarea" :rows="3" v-model="updateDialogForm.description")
          el-form-item(label="CUONA")
            .content
              el-table.group(ref="groupDeviceTable" :data="devices" @row-click="toggleGroupedDevice" @selection-change="setSelectedDevices" cell-class-name="el-table-cell" row-class-name="el-table-row" max-height="300")
                el-table-column(type="selection" width="35")
                el-table-column(prop="name" :label="$t('Cuona.Group.show_name')" sortable="")
                  template(slot-scope="props")
                    img.device-image(:src="getCuonaImage(props.row)")
                    span {{ props.row.name }}
                el-table-column(width="180px" prop="nfc_uid" :label="$t('Cuona.Group.nfc_uid')" sortable="")
                el-table-column(prop="groups" :label="$t('Cuona.Event.group')" sortable="")
                  template(slot-scope="props")
                    template(v-for="group in props.row.groups")
                      el-tag.group(size="mini") {{ group.name }}
                el-table-column(width="110px" prop="device_type" :label="$t('Cuona.Group.type')" :formatter="typeFormatter" sortable="")
        span.dialog-footer(slot="footer")
          el-button(@click="closeDialog" :disabled="isLoading") {{ $t('Cuona.Group.cancel') }}
          el-button(type="primary" @click="updateGroup" :disabled="isLoading") {{ $t('Cuona.Group.change') }}

      el-dialog(:title="$t('Cuona.Group.title06', {group_name: group.name})" :visible.sync="isShowingGroupDeleteDialog")
        p(v-html="nl2br($t('Cuona.Group.description01'))")
        .dialog-footer(slot="footer")
          el-button(@click="isShowingGroupDeleteDialog=false" :disabled="isLoading") {{ $t('Cuona.Group.cancel') }}
          el-button(type="danger" @click="deleteGroup" :disabled="isLoading") {{ $t('Cuona.Group.delete') }}

      el-dialog(:title="$t('Cuona.Device.set_device')" width="65%" top="8vh" :visible.sync="isShowingAddDevicesDialog" @closed="closedAddDevicesDialog")
        el-form.form(label-position="left" label-width="120px" ref="addDevicesDialogForm" :model="updateDialogForm" v-loading="isLoading")
          .content
            el-table.group(ref="addDevicesTable" :data="devices" @row-click="toggleAddDevices" @selection-change="setSelectedDevices" cell-class-name="el-table-cell" row-class-name="el-table-row" max-height="300")
              el-table-column(type="selection" width="35")
              el-table-column(prop="name" :label="$t('Cuona.Group.show_name')" sortable="")
                template(slot-scope="props")
                  img.device-image(:src="getCuonaImage(props.row)")
                  span {{ props.row.name }}
              el-table-column(width="180px" prop="nfc_uid" :label="$t('Cuona.Group.nfc_uid')" sortable="")
              el-table-column(prop="groups" :label="$t('Cuona.Event.group')" sortable="")
                template(slot-scope="props")
                  template(v-for="group in props.row.groups")
                    el-tag.group(size="mini") {{ group.name }}
              el-table-column(width="110px" prop="device_type" :label="$t('Cuona.Group.type')" :formatter="typeFormatter" sortable="")
        span.dialog-footer(slot="footer")
          el-button(@click="isShowingAddDevicesDialog=false" :disabled="isLoading") {{ $t('Cuona.Group.cancel') }}
          el-button(type="primary" @click="addDevices" :disabled="isLoading") {{ $t('Cuona.Group.change') }}

      el-dialog(:title="$t('Cuona.Event.set_event')" width="65%" top="8vh" :visible.sync="isShowingAddEventsDialog" @closed="closedAddEventsDialog")
        el-form.form(label-position="left" label-width="120px" ref="addEventsDialogForm" v-loading="isLoading")
          .content
            el-table.group(ref="groupEventTable" :data="events" @row-click="toggleGroupedEvent" @selection-change="setSelectedEvents" cell-class-name="el-table-cell" row-class-name="el-table-row" max-height="300")
              .empty(slot="empty")
                img(:src="images.empty")
                p(v-html="nl2br($t('Cuona.Event.description01'))")
              el-table-column(type="selection" width="35")
              el-table-column(prop="name" :label="$t('Cuona.Event.name')" sortable="")
              el-table-column(:label="$t('Cuona.Event.action')" sortable="")
                template(slot-scope="props") {{ showActions(props.row.action_type) }}
              el-table-column(prop="groups" :label="$t('Cuona.Event.group')" sortable="")
                template(slot-scope="props")
                  template(v-for="group in props.row.groups")
                    el-tag.group(size="mini") {{ group.name }}
              el-table-column(prop="description" :label="$t('Cuona.Event.note')")
        span.dialog-footer(slot="footer")
          el-button(@click="isShowingAddEventsDialog=false" :disabled="isLoading") {{ $t('Cuona.Group.cancel') }}
          el-button(type="primary" @click="addEvents" :disabled="isLoading") {{ $t('Cuona.Group.change') }}
</template>

<script>
import DevicesTable from '../DevicesTable'
import EventsTable from '../EventsTable'
import actions from '@/utils/defines/actions.js'
import GroupApi from '@/api/group'
import EventApi from '@/api/event'
import DeviceApi from '@/api/cuona'
import UserApi from '@/api/user'
export default {
  mixins: [actions],
  components: { DevicesTable, EventsTable },
  data () {
    return {
      group: null,
      events: [],
      devices: [],
      ownerAndManagers: [],
      selectedDevices: [],  // グループ更新時にチェックされたCUONA一覧
      selectedEvents: [],
      images:{
        cube: require('@/assets/cuona_cube.svg'),
        seal: require('@/assets/cuona_seal.svg')
      },
      isShowingGroupUpdateDialog: false,
      isShowingGroupDeleteDialog: false,
      isShowingAddDevicesDialog: false,
      isShowingAddEventsDialog: false,
      isLoading: false,
      deviceSettingDialogForm: {
        deviceId: '',
        deviceName: '',
        deviceStatus: true
      },
      updateDialogForm: {
        name: '',
        managerId: null,
        description: '',
        groupId: null
      },
      rules: {
        name: [
          { required: true, message: this.$t('Cuona.Group.message01'), trigger: 'blur' }
        ],
        managerId: [
          { required: true, message: this.$t('Cuona.Group.message02'), trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.getGroupEventsDevicesUsers(this.$route.params.id);
  },
  computed: {

    // 現在のグループに属しているデバイス一覧のIDの配列
    groupedDeviceIds: function() {
      return this.group.devices.map(function(device) {
        return device.id
      });
    },

    nfcUidsInGroup: function() {
      return this.group.devices.map(function(device) {
        return device.nfc_uid
      });
    },

    eventIdsInGroup: function() {
      return this.group.events.map(function(event) {
        return event.id
      });
    },

    // グループ更新時にチェックされたCUONA一覧のデバイスIDの配列
    selectedNfcUids: function() {
      return this.selectedDevices.map(function(selectedDevice) {
        return selectedDevice.nfc_uid
      });
    },
  },
  watch : {
    group : function() {
      if(this.group) {
        this.$store.commit('setLastBreadcrumb', this.group.name);
        this.setPageTitle(this.group.name);
      }
    },
  },
  methods: {

    getGroupEventsDevicesUsers: function (id){
      this.isLoading = true;
      const that = this;
      Promise.all([GroupApi.getGroup(id), EventApi.getEvents(), DeviceApi.getDevices(), UserApi.getUser(), UserApi.getManagers()])
        .then(function(values) {
          that.group = values[0];
          that.events = values[1];
          that.devices = values[2];
          that.ownerAndManagers = [values[3], ...values[4]];
        })
        .catch((error) => {
          this.$router.replace('/cuona/group');
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Group.failed_get'),
            type: 'error'
          });
        })
        .finally(() => { this.isLoading = false; });
    },

    // CUONAのアイコンを設定
    getCuonaImage: function(device) {
      return (device.device_type == 'seal') ? this.images.seal : this.images.cube
    },

    showActions: function(type){
      for(var i=0; i<this.actions.length; i++){
        if (this.actions[i].type == type) {
          return this.$t(this.actions[i].name)
        }
      }
    },

    // 表示するタイプを形成
    typeFormatter: function(row, column) {
      var type = this.$t('Cuona.Group.type01')
      if(row.device_type != 'cube') {
        type = this.$t('Cuona.Group.type02')
      }
      return type
    },

    // グループ作成時のCUONAのチェックをトグル
    toggleGroupedDevice: function(row, event, column) {
      this.$refs.groupDeviceTable.toggleRowSelection(row);
    },

    toggleGroupedEvent: function(row, event, column) {
      this.$refs.groupEventTable.toggleRowSelection(row);
    },

    toggleAddDevices: function(row, event, column) {
      this.$refs.addDevicesTable.toggleRowSelection(row);
    },

    // グループ作成時にチェックされたCUONA一覧を取得
    setSelectedDevices(selectedDevices) {
      this.selectedDevices = selectedDevices
    },

    setSelectedEvents(selectedEvents) {
      this.selectedEvents = selectedEvents
    },

    // グループの削除
    deleteGroup: function() {
      this.isLoading = true;
      GroupApi.deleteGroup(this.group.id)
        .then(() => {
          this.$router.replace('/cuona/group');
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Group.message04'),
            type: 'success'
          });
        })
        .catch((error) => {
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Group.failed_delete'),
            type: 'error'
          });
        })
        .finally(() => { this.isLoading = false; });
    },

    // グループの更新
    updateGroup: function() {
      this.$refs['updateDialogForm'].validate((valid) => {
        if (valid) {
          const payload = {
            groupId: this.group.id,
            params: {
              nfc_uids: this.selectedNfcUids,
              event_ids: this.eventIdsInGroup,
              group: {
                name: this.updateDialogForm.name,
                description: this.updateDialogForm.description,
                manager_id: this.updateDialogForm.managerId
              }
            }
          }
          this.callUpdateGroupApi(payload);
        } else {
          return false;
        }
      });
    },

    addDevices: function() {
      const payload = {
        groupId: this.group.id,
        params: {
          nfc_uids: this.selectedNfcUids
        }
      }
      this.callUpdateGroupApi(payload);
    },

    addEvents: function() {
      const selectedEventIds = [];
      if(0 < this.selectedEvents.length) {
        this.selectedEvents.forEach(function(selectedEvent) {
          selectedEventIds.push(selectedEvent.id);
        });
      }
      const payload = {
        groupId: this.group.id,
        params: {
          nfc_uids: this.nfcUidsInGroup,
          event_ids: selectedEventIds
        }
      }
      this.callUpdateGroupApi(payload);
    },

    callUpdateGroupApi: function(payload) {
      this.isLoading = true;
      GroupApi.updateGroup(payload)
        .then((group) => {
          this.group = group;
          this.isShowingGroupUpdateDialog = false;
          this.isShowingAddDevicesDialog = false;
          this.isShowingAddEventsDialog = false;
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Group.message05'),
            type: 'success'
          });
        })
        .catch((error) => {
          let errorMessage = 'Cuona.Group.failed_update';
          switch(error.code) {
            case 409:
              errorMessage = 'Cuona.Group.has_dup_name_group';
              break;
          }
          this.$message({
            showClose: true,
            message: this.$t(errorMessage),
            type: 'error'
          });
        }).finally(() => { this.isLoading = false; });
    },

    // グループ更新ダイアログを開く
    openUpdateDialog: function() {
      this.updateDialogForm.name = this.group.name
      this.updateDialogForm.managerId = this.group.manager.id
      this.updateDialogForm.description = this.group.description
      this.isShowingGroupUpdateDialog = true
    },

    // グループ更新ダイアログを開いた後の処理
    openedUpdateDialog: function() {
      this.$nextTick(() => {
        for(var i = 0; i < this.devices.length; i++) {
          if (this.groupedDeviceIds.indexOf(this.devices[i].id) >= 0){
            this.$refs.groupDeviceTable.toggleRowSelection(this.devices[i])
          }
        }
      })
    },

    // グループ更新ダイアログを閉じる
    closeDialog: function() {
      this.isShowingGroupUpdateDialog = false;
      this.isShowingAddDevicesDialog = false;
      this.isLoading = false;
    },

    // グループ更新ダイアログを閉じた後の処理
    closedDialog: function() {
      this.$refs['updateDialogForm'].resetFields();
      this.$refs.groupDeviceTable.clearSelection();
      this.updateDialogForm.managerId = null;
    },

    closedAddEventsDialog: function() {
      this.$refs['addEventsDialogForm'].resetFields();
      this.$refs.groupEventTable.clearSelection();
    },

    closedAddDevicesDialog: function() {
      this.$refs['addDevicesDialogForm'].resetFields();
      this.$refs.addDevicesTable.clearSelection();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables.scss";
@import "../../../styles/table-layout.scss";

.groupInfo {
  min-height: 20vh;
  background: #FFF;
  border-radius: 5px;
  margin: 40px;
  padding: 0;
  border: 1px solid $border;
}

.info {
  padding-bottom: 30px;
}

.groupInfo {
  padding-bottom: 5px;
  h1 {
    margin:  30px 40px 0 40px;
    font-size: 24px;
    font-weight: normal;
  }

  h2 {
    margin: 30px 0 10px 10px;
    font-size: 18px;
    font-weight: 500;
  }

  h3 {
    margin: 0 40px;
    margin-bottom: 3px;
    font-size: 16px;
    font-weight: normal;
  }
}

.attached, .events {
  border-top: 1px solid $border;
  padding: 0 30px 40px 30px;

  .el-table ::v-deep {

    th {
      font-weight: normal;
      font-size: 12px;
      padding: 0;
      color: #999;
    }

    td {
      font-size: 13px;
    }
  }
}

p.note {
  margin: 0 0 10px 0;
  padding: 0 40px 10px 40px;
  font-size: 14px;
  color: #999;
}

p.manager {
  padding: 0 40px;
  font-size: 14px;
}
span.manager {
  margin-left: 10px;
}

.bottons {
  margin: -20px 10px 0 0;
  float: right;
}

.el-dialog {

  .content {
    margin: 0;
  }

  .device-image {
    position: relative;
    top:4px;
    width: 20px;
    margin-right: 8px;
  }

  th {
    font-weight: normal;
    font-size: 12px;
    padding: 0 20px;
    color: #999;
  }

  .el-table-row {
    height: 40px;
  }
}

.form {
  margin-top: 10px;
}

a {
  transition: all .3s ease-in-out;
  color: #666;
  &:hover {
    color: $safe;
  }
}

.group-select {
  width: 100%;
}

span.count {
  display: inline-block;
  text-align: center;
  background: $border;
  min-width: 20px;
  padding: 1px 6px;
  font-size: 12px;
  border-radius: 15px;
  margin-left: 8px;
}

</style>
